import React from "react";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  TwoColumnSectionBase,
} from "@reusejs/react";

export interface FadedRightImageProps {
  title: string;
  description: string;
  image: any;
}

export default function FadedRightImage(props: FadedRightImageProps) {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-gray-50 overflow-hidden",
        innerContainerStyles:
          "w-full mx-auto px-4 sm:px-6 xl:px-0 max-w-7xl mx-auto",
      }}
    >
      <div className="relative">
        <TwoColumnSectionBase
          firstColumnEl={
            <IconTitleDescriptionActionCard
              title={props.title}
              description={props.description}
              itemTitleDescriptionCardBaseClasses={{
                wrapper: "relative pt-8 md:pt-16 sm:pb-8",
                titleWrapper: "text-left",
                titleStyles:
                  "text-xl font-bold md:text-3xl md:font-extrabold text-gray-900 md:leading-none md:tracking-tight lg:text-4xl",
                descriptionWrapper: "text-left mt-1 md:mt-4",
                descriptionStyles:
                  "max-w-xl text-base md:text-lg text-gray-500",
              }}
            />
          }
          secondColumnEl={
            <div className="w-full relative sm:absolute bottom-0 xl:inset-0 xl:h-full">
              <div className="h-full w-full xl:grid xl:grid-cols-2">
                <div className="h-full xl:relative xl:col-start-2 flex justify-end lg:justify-start sm:justify-start sm:-ml-10 lg:ml-20 xl:justify-end xl:mr-10">
                  {props.image}
                </div>
              </div>
            </div>
          }
          twoColumnSectionBaseClasses={{
            firstElWrapperStyles: "w-full flex md:w-1/2 sm:pr-16",
            secondElWrapperStyles: "w-full md:w-1/2 mt-4 sm:mt-0 md:pl-16",
            columnsFlexWrapperStyles:
              "flex justify-between flex-col md:flex-row",
          }}
        />
      </div>
    </SectionContainerBase>
  );
}
